import Modal from "../Modal";

export default function Status({ message }: { message?: string }) {
  return (
    <Modal>
      <div>{message}</div>
    </Modal>
  );
}
